
import { defineComponent } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { spatialOmicsApi } from '@/request/index'
import { Biotech } from "@/types/Request";

export default defineComponent({
  data () {
    return {
      biotechListData: [],
      pageSize: 2,
      columnSize: 4,
      currentPageData: [],
      currentPage: 1,
      currentBiotech: '',
      router: useRouter(),
      store: useStore()
    }
  },
  computed: {
    /**
     * 获取当前的biotech类别，用于更新BiotechListView组件
     */
    selectedBiotechCategory () {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return this.store.state.selectedBiotechCategory
    }
  },
  methods: {
    /**
     * 根据biotech类别请求获取biotech列表，并更新BiotechListView组件相关数据
     * @param biotechType
     */
    getBiotechListData (biotechType: string) {
      spatialOmicsApi.getBiotechListByBiotechType(biotechType).then((res) => {
        console.log('res', res)
        this.biotechListData = []
        for (let i = 0; i < res.data.length; i += this.columnSize) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.biotechListData.push(res.data.slice(i, i + this.columnSize))
        }
        console.log('biotechListData', this.biotechListData)
        this.gotoPage(1)
        console.log('currentPageData', this.currentPageData)
      })
    },

    /**
     * 跳至biotech的某一页
     * @param whichPage 页码数
     */
    gotoPage (whichPage: number) {
      let currentPage = whichPage || this.currentPage
      let start = this.pageSize * (currentPage - 1)
      let end = start + this.pageSize
      this.currentPageData = this.biotechListData.slice(start, end)
      this.currentPage = currentPage
    },

    /**
     * 设置当前biotech，并更新DatasetListView组件
     * @param cItem
     */
    selectBiotech (cItem: Biotech) {
      console.log(cItem)
      this.router.push({
        name: 'datasetList',
        query: {
          biotechID: cItem.id
        }
      })
      this.store.commit('setBiotechID', cItem.id)
      this.store.commit('setBiotechName', cItem.name)
      this.store.commit('setBiotechVisible', true)
    }
  },
  mounted() {
    console.log('----------route----------', this.$route.query)
    // eslint-disable-next-line no-prototype-builtins
    if (this.$route.query.hasOwnProperty('biotechType')) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.getBiotechListData(this.$route.query['biotechType'])
    }
  },
  watch: {
    selectedBiotechCategory (newVal) {
      this.getBiotechListData(newVal)
    }
  }
})
